import { HttpClient, HttpContext, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ApiResponse,
  FetchResponse,
} from "src/app/shared/models/api-response.interface";
import { environment } from "src/environments/environment";
import { ProductResponse } from "../../product-list/models/product-interface";
import { SKIP_ERROR_TOAST } from "src/app/core/interceptors/error.interceptor";

@Injectable({
  providedIn: "root",
})
export class PopularProductApiService {
  apiUrl!: string;
  apiV!: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }
  fetchPopularProduct() {
    return this.httpClient.get<ApiResponse<FetchResponse<ProductResponse[]>>>(
      this.apiUrl + `/api/${this.apiV}/Product/home-page`,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
    );
  }

  fetchCuratedDesignProducts() {
    return this.httpClient.get<ApiResponse<FetchResponse<ProductResponse[]>>>(
      this.apiUrl + `/api/${this.apiV}/Product/home-design/selected`,
      { context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
    );
  }

  fetchDesignProducts(minQuantity: number | null, pageIndex = 0, search = '') {
    let params = minQuantity === null
      ? new HttpParams()
      : new HttpParams().set('MoqRange', minQuantity);
    params = params.set('pageIndex', pageIndex);
    if (search.trim()) params = params.set('Search', search.trim());
    return this.httpClient.get<ApiResponse<FetchResponse<ProductResponse[]>>>(
      this.apiUrl + `/api/${this.apiV}/Product/home-design`,
      { params, context: new HttpContext().set(SKIP_ERROR_TOAST, true) }
    );
  }
}
